import React from 'react';
import FormLabel from '../FormLabel/FormLabel';
import { FormLabelModifier, FormLabelContainerModifier } from '../FormLabel/FormLabel';

type FormRadioType = {
  id: string;
  type: string;
  name: string;
  value: string;
  checked?: boolean;
  required: boolean;
  labelTitle: string;
  disabled?: boolean;
  onChange: any;
};

export default function FormRadio({
  type,
  name,
  value,
  checked,
  required,
  labelTitle,
  onChange,
  id,
  disabled,
}: FormRadioType) {
  return (
    <div className={disabled ? 'form-radio--disabled' : 'form-radio'}>
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
      <input
        id={`${name}-${value}-${id}`}
        className="form-radio__input"
        type={type}
        name={name}
        value={value}
        checked={checked}
        required={required}
        disabled={disabled}
        onChange={onChange}
      />
      <FormLabel
        htmlFor={`${name}-${value}-${id}`}
        modifier={[FormLabelModifier.VERTICAL_ALIGN, FormLabelModifier.RADIO]}
        containerModifier={FormLabelContainerModifier.NO_MARGIN}
      >
        {labelTitle}
      </FormLabel>
    </div>
  );
}
